/* eslint-disable no-mixed-spaces-and-tabs */
// eslint-disable-next-line no-unused-vars
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "./gnp-multicanal.css";

const mapDispatch = (dispatch) => {
	return {
		setFlujoMulticanal: (flujo) => {
			dispatch({type: "SET_FLUJO_MULTICANAL", flujo: flujo});
		},
		resetFlujoMulticanal: () => {
			dispatch({ type: "RESET_FLUJO_MULTICANAL" });
		}
	};
};

const mapState = state => {
	return {
		loading: state.global.loading,
		nombre: state.global.nombre,
		multicanalGnp: state.multicanalGnp
	};
};

class MulticanalAcciones extends Component {

	componentWillMount(){
		this.props.resetFlujoMulticanal();
	}

   setFlujo = (flujo) => {
		let $this = this;
      $this.props.setFlujoMulticanal(flujo);
   }
   
   render() {
   	return (
   		<li className="detalle-download-btn acciones-multicanal" >
   			<div className="btn-group-vertical" role="group" aria-label="...">
   				<button type="button" className="btn-acciones btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Acciones <span className="caret"></span>
   				</button>
   				<ul className="dropdown-menu dropdown-menu-right">
   					{!this.props.isMascotasPoliza && <li className="item-drop acciones">
							<div className="dropdown-divider"></div>
							<span className="dropdown-header">ASITENCIAS</span>
   						<button type="button" className="dropdown-item" onClick={this.setFlujo.bind(this, "ALTA_ASISTENCIA")}>
                        Alta de asistencia
   						</button>
   					</li>}
   					{!this.props.isMascotasPoliza && <li className="item-drop acciones">
							<div className="dropdown-divider"></div>
							<span className="dropdown-header">SERVICIOS</span>
   						<button type="button" className="dropdown-item" onClick={this.setFlujo.bind(this, "ALTA_SINIESTRO")}>
                        Alta de siniestro
   						</button>
   					</li>}
					{this.props.isMascotasPoliza && <li className="item-drop acciones">
							<div className="dropdown-divider"></div>
							<span className="dropdown-header">SERVICIOS</span>
   						<button type="button" className="dropdown-item" onClick={this.setFlujo.bind(this, "siniestro-mascotas")}>
						   Alta de siniestro
   						</button>
   					</li>}
					   {this.props.isMascotasPoliza && <li className="item-drop acciones">
							<div className="dropdown-divider"></div>
							<span className="dropdown-header">SERVICIOS</span>
   						<button type="button" className="dropdown-item" onClick={this.setFlujo.bind(this, "seguimiento-mascota")}>
						    Seguimiento
   						</button>
   					</li>}
					{this.props.isMascotasPoliza && <li className="item-drop acciones">
							<div className="dropdown-divider"></div>
							<span className="dropdown-header">SERVICIOS</span>
   						<button type="button" className="dropdown-item" onClick={this.setFlujo.bind(this, "historial-mascota")}>
						   Historial mascota
   						</button>
   					</li>}
   				</ul>
   			</div>
   		</li>
   	);
   }
}

MulticanalAcciones.propTypes = {
	loading: PropTypes.bool,
	cliente: PropTypes.string,
};

export default connect(mapState, mapDispatch)(MulticanalAcciones);


// WEBPACK FOOTER //
// ./src/gnp-multicanal/multicanalAcciones.cpmt.js